import { Slider, Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { StyledStack } from '../Stack';
import { formatNumber } from 'utils/helper';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
const defaultValue = [0, 1000];
const StyledSlider = props => {
  const [value, setValue] = useState(props.defaultValue ?? defaultValue);
  const translations = useSelector(selectTranslations);
  return (
    <div style={{ ...props.containerStyle }}>
      <StyledStack
        alignItem={{ lg: 'flex-end', md: 'flex-start', xs: 'flex-start' }}
        columnGap={'20px'}
        direction={{ lg: 'row', md: 'column', xs: 'column' }}
      >
        <Typography
          style={{ marginBottom: 3, color: '#808080', fontWeight: 500 }}
        >
          {translations?.['b2b.txt.total-amount']}
        </Typography>
        <div>
          <StyledStack justifyContent={'space-between'}>
            <Typography style={{ color: '#f06f24', fontWeight: '500' }}>
              {formatNumber(value[0] * 50000000).replaceAll(',', '.') + 'đ'}
            </Typography>
            <Typography style={{ color: '#f06f24', fontWeight: '500' }}>
              {formatNumber(value[1] * 50000000).replaceAll(',', '.') + 'đ'}
            </Typography>
          </StyledStack>
          <SliderWrapper
            tooltipVisible={false}
            step={2}
            max={1000}
            range
            style={{ width: 255, marginTop: 7, marginBottom: 7 }}
            value={value}
            onChange={val => {
              setValue(val);
              props.onChangeCallBack &&
                props.onChangeCallBack(val.map(i => i * 50000000));
            }}
            {...props}
          />
        </div>
      </StyledStack>
    </div>
  );
};

export default StyledSlider;

export const SliderWrapper = styled(Slider)`
  .ant-slider-handle {
    border: 6px solid #f06f24 !important;
    height: 10px;
    width: 10px;
    box-sizing: content-box;
    margin-top: -9px;
  }
  .ant-slider-track {
    height: 6px;
    background-color: #f06f24 !important;
  }
  .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
    border-color: #f06f24 !important;
  }
  .ant-slider:hover .ant-slider-track {
    border-color: #f06f24 !important;
  }
  .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
    border-color: #f06f24 !important;
  }
  .ant-slider-handle:focus {
    box-shadow: 0 0 0 5px #f06f2433;
  }
`;
